import { GetterTree } from 'vuex';
import { TagsState, RootState } from '../types';

export const getters: GetterTree<TagsState, RootState> = {

	/**
	 * Get all tags, sorted by created date
	 *
	 * @returns {MenuItemTag[]}
	 */
	getAllTags: (state): MenuItemTag[] => {
		return [...state.tags].sort((a, b) => +a.created_at - +b.created_at);
	}
};
